module.exports = __webpack_public_path__ + "static/img/qr_gzh.ad91f55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr_gzh.png
// module id = +zt1
// module chunks = 13